/* eslint-disable import/no-internal-modules */
import { TranslationCategory } from '@insided/deprecated-libs/translationsUtils/translations'
import { fetchPhrase } from '@insided/deprecated-libs/translationsUtils/phrase'
import { ContentType } from '@insided/shared/utils/contentType'

export async function fetchPhrases(
  phrasesSet: Array<{ module: TranslationCategory, key: string }>
) {
  return await Promise.all(
    phrasesSet.map(
      async (p) =>
        await new Promise((resolve) => fetchPhrase(p.module, p.key, (phrs) => resolve(phrs)))
    )
  )
}

type BackToOverviewLink = {
  [key in ContentType]?: {
    name: string
    link: string
  }
}

export const backToOverviewLink: BackToOverviewLink = {
  idea: {
    name: 'Ideas overview',
    link: '/idea/overview'
  },
  productUpdate: {
    name: 'Product updates overview',
    link: '/product-update/overview'
  },
  question: {
    name: 'Back to Overview',
    link: '/overview'
  },
  conversation: {
    name: 'Back to Overview',
    link: '/overview'
  },
  article: {
    name: 'Articles Overview',
    link: '/article/overview'
  }
}
